import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { obterPaises, obterTiposLogradouro, obterTitulosLogradouro } from '../../api/dominioAPI';
import {
  alterarIntegrantePreFamilia,
  enviarPreCadastroCaixa,
  excluirIntegrantePreFamilia,
  inserirIntegrantePreFamilia,
  obterContatoPreFamilia,
  obterDadosBasicosPreFamilia,
  obterDadosIntegrantePreFamilia,
  obterEnderecoPreFamilia,
  obterOrgaosEmissores,
  salvarContatoPreFamilia,
  salvarEnderecoPreFamilia,
  verificarElegibilidadeIntegrante
} from '../../api/preCadastroAPI';
import { obterMunicipiosPorUF, obterUFs, obterDadosCep } from '../../api/recursosAPI';
import { RootState } from '../../app/store';

export interface PreCadastroState {
  preFamilia: any;
  contatos: any;
  enderecoFamilia: any;
  integrantesFamilia: any[];
  integranteSelecionado: any;
  ufs: any[];
  municipios: any[];
  tiposLogradouro: any[];
  titulosLogradouro: any[];
  paises: any[];
  orgaosEmissores: any[];
  responseError: any;
  dadosCep: any;
  encontrouCep: any;
  exibirTutorial: boolean;
  exibirMensagem: boolean;
}

const initialState: PreCadastroState = {
  preFamilia: null,
  contatos: null,
  enderecoFamilia: null,
  integrantesFamilia: [],
  integranteSelecionado: null,
  ufs: [],
  municipios: [],
  tiposLogradouro: [],
  titulosLogradouro: [],
  paises: [],
  orgaosEmissores: [],
  responseError: null,
  dadosCep: null,
  encontrouCep: null,
  exibirTutorial: true,
  exibirMensagem: true
};

export const iniciarPreCadastro = createAsyncThunk(
  'preCadastro/iniciarPreCadastro',
  async (cpf: string) => {
    return obterDadosBasicosPreFamilia(cpf);
  }
);

export const getDadosEndereco = createAsyncThunk(
  'preCadastro/getDadosEndereco',
  async (idPreFamilia: number) => {
    return obterEnderecoPreFamilia(idPreFamilia);
  }
);
export const salvarDadosEndereco = createAsyncThunk(
  'preCadastro/salvarDadosEndereco',
  async (data: any) => {
    return salvarEnderecoPreFamilia(data.idPreFamilia, data.dadosEndereco);
  }
);

export const getDadosContatos = createAsyncThunk(
  'preCadastro/getDadosContatos',
  async (idPreFamilia: number) => {
    return obterContatoPreFamilia(idPreFamilia);
  }
);

export const salvarDadosContatos = createAsyncThunk(
  'preCadastro/salvarDadosContatos',
  async (data: any) => {
    return salvarContatoPreFamilia(data.idPreFamilia, data.dadosContato);
  }
);

export const getDadosIntegrante = createAsyncThunk(
  'preCadastro/getDadosIntegrante',
  async (data: any) => {
    return obterDadosIntegrantePreFamilia(data.idPreFamilia, data.idIntegrante);
  }
);
export const inserirIntegrante = createAsyncThunk(
  'preCadastro/inserirIntegrante',
  async (data: any) => {
    try {
      const response = await inserirIntegrantePreFamilia(data.idPreFamilia, data.dadosIntegrante);
      data.history.push('/preCadastro');
      return response;
    } catch (e) {
      throw e;
    }
  }
);
export const alterarIntegrante = createAsyncThunk(
  'preCadastro/alterarIntegrante',
  async (data: any) => {
    try {
      const response = await alterarIntegrantePreFamilia(data.idPreFamilia, data.dadosIntegrante);
      data.history.push('/preCadastro');
      return response;
    } catch (e) {
      throw e;
    }
  }
);
export const excluirIntegrante = createAsyncThunk(
  'preCadastro/excluirIntegrante',
  async (data: any) => {
    return excluirIntegrantePreFamilia(data.idPreFamilia, data.idIntegrante);
  }
);

export const getUfs = createAsyncThunk(
  'preCadastro/getUfs',
  async () => {
    return obterUFs();
  }
);
export const getMunicipios = createAsyncThunk(
  'preCadastro/getMunicipios',
  async (codigoUfIbge: number) => {
    return obterMunicipiosPorUF(codigoUfIbge);
  }
);
export const getTiposLogradouro = createAsyncThunk(
  'preCadastro/getTiposLogradouro',
  async () => {
    return obterTiposLogradouro();
  }
);
export const getTitulosLogradouro = createAsyncThunk(
  'preCadastro/getTitulosLogradouro',
  async () => {
    return obterTitulosLogradouro();
  }
);
export const getPaises = createAsyncThunk(
  'preCadastro/getPaises',
  async () => {
    return obterPaises();
  }
);
export const getOrgaosEmissores = createAsyncThunk(
  'preCadastro/getOrgaosEmissores',
  async () => {
    return obterOrgaosEmissores();
  }
);

export const enviarPreCadastro = createAsyncThunk(
  'preCadastro/enviarPreCadastro',
  async (data: any) => {
    return enviarPreCadastroCaixa(data.idPreFamilia, data.cpf, data.ip);
  }
);

export const getCep = createAsyncThunk(
  'preCadastro/getCep',
  async (cep: any) => {
    return obterDadosCep(cep);
  }
);

export const buscarDadosIntegrantePorCPF = createAsyncThunk(
  'preCadastro/buscarDadosIntegrantePorCPF',
  async (dados: { cpf: string; cpfUsuarioLogado: string, dataNascimento: any; history: any }) => {
    try {
      const response = await verificarElegibilidadeIntegrante(
        dados.cpf,
        dados.cpfUsuarioLogado,
        moment(dados.dataNascimento).format('DD-MM-YYYY')
      );
      dados.history.push('/preCadastro/integrante');
      return response;
    } catch (e) {
      const rootEl = document.getElementById('root');
      rootEl?.scrollTo(0, 0);
      throw e;
    }
  }
);

export const preCadastroSlice = createSlice({
  name: 'preCadastro',
  initialState,
  reducers: {
    setIntegrante: (state, action) => {
      state.responseError = initialState.responseError;
      state.integranteSelecionado = action.payload;
    },
    setEnderecoFamilia: (state, action) => {
      state.enderecoFamilia = action.payload;
    },
    setContatosFamilia: (state, action) => {
      state.contatos = action.payload;
    },
    setExibirTutorial: (state, action) => {
      state.exibirTutorial = action.payload;
    },
    setAlterarExibirMensagem: (state, action) => {
      state.exibirMensagem = action.payload;
    },
    limparMunicipios: (state) => {
      state.municipios = initialState.municipios;
    },
    limparResponseError: (state) => {
      state.responseError = initialState.responseError;
    },
    limparCep: (state) => {
      state.dadosCep = initialState.dadosCep;
    },
    limparEndereco: (state) => {
      state.enderecoFamilia = initialState.enderecoFamilia;
    },
    limparEncontrouCep: (state) => {
      state.encontrouCep = initialState.encontrouCep;
    },
    limparIntegranteSelecionado: (state) => {
      state.integranteSelecionado = initialState.integranteSelecionado;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(iniciarPreCadastro.fulfilled, (state, action) => {
      state.preFamilia = action.payload;
    });
    builder.addCase(getDadosEndereco.fulfilled, (state, action) => {
      state.enderecoFamilia = action.payload;
    });
    builder.addCase(getDadosContatos.fulfilled, (state, action) => {
      state.contatos = action.payload;
    });
    builder.addCase(getDadosIntegrante.fulfilled, (state, action) => {
      state.integranteSelecionado = action.payload;
    });
    builder.addCase(getUfs.fulfilled, (state, action) => {
      state.ufs = action.payload;
    });
    builder.addCase(getMunicipios.fulfilled, (state, action) => {
      state.municipios = action.payload;
    });
    builder.addCase(getTiposLogradouro.fulfilled, (state, action) => {
      state.tiposLogradouro = action.payload;
    });
    builder.addCase(getTitulosLogradouro.fulfilled, (state, action) => {
      state.titulosLogradouro = action.payload;
    });
    builder.addCase(getPaises.fulfilled, (state, action) => {
      state.paises = action.payload;
    });
    builder.addCase(getOrgaosEmissores.fulfilled, (state, action) => {
      state.orgaosEmissores = action.payload;
    });
    builder.addCase(alterarIntegrante.rejected, (state, action) => {
      state.responseError = action.error;
    });
    builder.addCase(inserirIntegrante.rejected, (state, action) => {
      state.responseError = action.error;
    });
    builder.addCase(enviarPreCadastro.rejected, (state, action) => {
      state.responseError = action.error;
    });
    builder.addCase(getCep.fulfilled, (state, action) => {
      if (action && action.payload) {
        state.dadosCep = action.payload;
        state.encontrouCep = true;
      } else {
        state.encontrouCep = false;
      }
    });
    builder.addCase(getCep.rejected, (state, action) => {
      state.responseError = action.error;
      state.encontrouCep = false;
    });

    builder.addCase(buscarDadosIntegrantePorCPF.fulfilled, (state, action) => {
      if (
        state.integranteSelecionado &&
        state.integranteSelecionado.id &&
        state.integranteSelecionado.preDocumentos
      ) {
        state.integranteSelecionado.nomePessoa = action.payload.nomePessoa;
        state.integranteSelecionado.nomeCompletoMae = action.payload.nomeCompletoMae;
        state.integranteSelecionado.dataNascimento = action.payload.dataNascimento;
        state.integranteSelecionado.preDocumentos.numeroCpfPessoa =
          action.payload.preDocumentos.numeroCpfPessoa;
      } else {
        state.integranteSelecionado = action.payload;
      }
    });
    builder.addCase(buscarDadosIntegrantePorCPF.rejected, (state, action) => {
      state.responseError = action.error;
    });
  },
});

export const {
  setIntegrante,
  setEnderecoFamilia,
  setContatosFamilia,
  setExibirTutorial,
  limparMunicipios,
  limparResponseError,
  limparCep,
  limparEndereco,
  limparEncontrouCep,
  limparIntegranteSelecionado,
  setAlterarExibirMensagem
} = preCadastroSlice.actions;

export const selectPreFamilia = (state: RootState) => state.preCadastro.preFamilia;
export const selectIntegrante = (state: RootState) => state.preCadastro.integranteSelecionado;
export const selectContatos = (state: RootState) => state.preCadastro.contatos;
export const selectEnderecoFamilia = (state: RootState) => state.preCadastro.enderecoFamilia;
export const selectIntegrantesFamilia = (state: RootState) => state.preCadastro.integrantesFamilia;
export const selectUfs = (state: RootState) => state.preCadastro.ufs;
export const selectMunicipios = (state: RootState) => state.preCadastro.municipios;
export const selectTiposLogradouro = (state: RootState) => state.preCadastro.tiposLogradouro;
export const selectTitulosLogradouro = (state: RootState) => state.preCadastro.titulosLogradouro;
export const selectPaises = (state: RootState) => state.preCadastro.paises;
export const selectOrgaosEmissores = (state: RootState) => state.preCadastro.orgaosEmissores;
export const selectResponseError = (state: RootState) => state.preCadastro.responseError;
export const selectCep = (state: RootState) => state.preCadastro.dadosCep;
export const selectEncontrouCep = (state: RootState) => state.preCadastro.encontrouCep;
export const selectExibirTutorial = (state: RootState) => state.preCadastro.exibirTutorial;
export const selectExibirMensagem = (state: RootState) => state.preCadastro.exibirMensagem;

export default preCadastroSlice.reducer;
